import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'

export class DynamicTabsBlock extends React.PureComponent<
  DynamicTabsBlock.Props,
  DynamicTabsBlock.State
> {
  public static sectionId = 'tabsblo';

  public render(): JSX.Element {
    const { maxwidth, style } = this.props.section.settings
    const tabs = this.props.section.blocks.map((block) => {
      return block.settings
    })
    const margins =
      maxwidth === 'Align with Footer'
        ? 'mx-1-6 sm:mx-2-4 2xl:mx-22 xl:mx-2-8'
        : undefined
    const maxWidth =
      maxwidth !== 'Full' && maxwidth !== 'Align with Footer'
        ? maxwidth
        : undefined
    const itemWidth = tabs.length > 3 ? `w-1/${tabs.length}` : 'w-1/3'

    const tabStyle = style == 'uppercase' ? 'uppercase tracking-wider text-xs font-bold' : ''

    return (
      <>
        <section className={'dynamic-tabs-block'}>
          <div
            style={{ maxWidth }}
            className={`${!maxWidth && 'max-w-container'} ${margins ||
              'mx-auto'} mt-4 mb-2 lg:mb-14-5 relative`}
          >
            <div className="flex w-full h-4 justify-center">
              {tabs.map((tab, index) => (
                <a
                  key={index}
                  className={`${itemWidth} ${tabStyle} text-center cursor-pointer border-b ${
                    tab.active
                      ? 'font-bold border-black'
                      : 'border-grey-dark'
                  }`}
                  href={tab.taburl}
                >
                  <div
                    className={`${tab.active ? 'font-bold' : 'text-grey-dark'}`}
                  >
                    {tab.title}
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
      </>
    )
  }
}

export namespace DynamicTabsBlock {
  export interface Options
    extends ShopifyNext.Section<{
      tabs: Array<{
        title: string;
        active: string;
        taburl: string;
      }>;
      style?: string;
      maxwidth: string;
    }> {}
  export interface Props extends GlobalProps {
    section: DynamicTabsBlock.Options;
  }
  export interface State {}
}
